module.exports = __webpack_public_path__ + "staticcomp/img/content_3副本.2204bbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_3副本.jpg
// module id = 1TIQ
// module chunks = 39